"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var react_router_dom_1 = require("react-router-dom");
var logo_header_png_1 = __importDefault(require("../../static/images/logo_header.png"));
var nav_1 = require("../nav");
function Header() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    function goHome() {
        navigate("/");
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: index_css_1.default.header },
            react_1.default.createElement("img", { src: logo_header_png_1.default, alt: "logo-header", className: index_css_1.default.logo, onClick: goHome }),
            react_1.default.createElement(nav_1.Nav, null))));
}
exports.Header = Header;
